module.exports = __webpack_public_path__ + "static/media/loop_new.2f882503.mp3";